<section class="banner_Section">
    <ngb-carousel [showNavigationArrows]="heroImageList?.length > 1"
        [showNavigationIndicators]="heroImageList?.length > 1">
        <ng-template *ngFor="let hero of heroImageList" ngbSlide>
            <div class="hero-image">
                <img [src]="hero.image" class="img-responsive" alt="Random first slide" />
            </div>
            <div class="carousel-caption">
                <div class="bnrtxt">
                    <div class="container">
                        <div class="bnrtxtinr">
                            <h1>
                                <span class="yellow headerLevel3"> {{ hero.heading }} </span><br />
                                <span class="headerLevel2">{{hero.subHeading }}</span>
                            </h1>
                            <button (click)="navigateToPage(hero)" class="btn primary-ebtn">{{ hero.navigationText
                                }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </ngb-carousel>
</section>